import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { dropRemovedUploadEntries } from './slice';
import type { UploaderCollectionsAppState } from './types';

const initialState: UploaderCollectionsAppState = {};

export const uploaderCollectionsSlice = createSlice({
  name: 'uploader_collections',
  initialState,
  reducers: {
    uploaderAddCollections: (
      state,
      action: PayloadAction<UploaderCollectionsAppState>,
    ) => {
      Object.assign(state, action.payload);
    },
  },
  extraReducers: dropRemovedUploadEntries,
});

export const { uploaderAddCollections } = uploaderCollectionsSlice.actions;

export const uploaderCollectionsReducer = uploaderCollectionsSlice.reducer;
